import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagEditlContainer from '../../containers/tag/TagEditContainer';
import { tagActions } from '../../store/modules/tag';

class TagCreate extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 태그 데이터 초기화
   */
  initiate = (tagId) => {
    const { getTagDetail } = this.props;
    getTagDetail({
      tagId,
    });
  };

  render() {
    const { editTag } = this.props;

    return (
      <PageTemplate pageName={TAG_PAGE_NAME.TAG_EDIT}>
        <TagEditlContainer onSubmit={editTag} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  getTagDetail: tagActions.getTagDetail,
  editTag: tagActions.editTag,
};

export default connect(null, mapDispatchToProps)(withRouter(TagCreate));
